const ANIMATION_DURATION = 320;
const EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';

const prefersReducedMotion = () =>
	window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const updateSummaryState = (details, summary, isOpen = details.open) => {
	const label = summary.querySelector('.fc-read-more__label');
	const indicator = summary.querySelector('.fc-read-more__indicator');

	if (label) {
		label.textContent = isOpen
			? label.dataset.labelOpen || 'Read less'
			: label.dataset.labelClosed || 'Read more';
	}

	if (indicator) {
		indicator.textContent = indicator.dataset.indicatorClosed || '+';
		indicator.classList.toggle('is-open', isOpen);
	}
};

const resetContentStyles = (content) => {
	content.style.height = '';
	content.style.opacity = '';
	content.style.transition = '';
	content.style.overflow = '';
};

const runTransition = (content, onComplete) => {
	let completed = false;

	const finish = () => {
		if (completed) {
			return;
		}

		completed = true;
		content.removeEventListener('transitionend', handleTransitionEnd);
		onComplete();
	};

	const handleTransitionEnd = (event) => {
		if (event.target === content && event.propertyName === 'height') {
			finish();
		}
	};

	content.addEventListener('transitionend', handleTransitionEnd);
	window.setTimeout(finish, ANIMATION_DURATION + 80);
};

const expandDetails = (details, content) => {
	details.open = true;
	details.dataset.animating = 'true';
	updateSummaryState(details, details.querySelector('summary'));

	content.style.overflow = 'hidden';
	content.style.height = '0px';
	content.style.opacity = '0';

	window.requestAnimationFrame(() => {
		content.style.transition = `height ${ANIMATION_DURATION}ms ${EASING}, opacity ${ANIMATION_DURATION}ms ${EASING}`;
		content.style.height = `${content.scrollHeight}px`;
		content.style.opacity = '1';
	});

	runTransition(content, () => {
		resetContentStyles(content);
		delete details.dataset.animating;
	});
};

const collapseDetails = (details, content) => {
	details.dataset.animating = 'true';
	updateSummaryState(details, details.querySelector('summary'), false);

	content.style.overflow = 'hidden';
	content.style.height = `${content.scrollHeight}px`;
	content.style.opacity = '1';

	window.requestAnimationFrame(() => {
		content.style.transition = `height ${ANIMATION_DURATION}ms ${EASING}, opacity ${ANIMATION_DURATION}ms ${EASING}`;
		content.style.height = '0px';
		content.style.opacity = '0';
	});

	runTransition(content, () => {
		details.open = false;
		resetContentStyles(content);
		delete details.dataset.animating;
	});
};

const initReadMore = (block) => {
	const details = block.querySelector('details');
	const summary = details?.querySelector('summary');
	const content = details?.querySelector('.fc-read-more__content');

	if (!details || !summary || !content || details.dataset.fcReadMoreInit) {
		return;
	}

	details.dataset.fcReadMoreInit = 'true';
	updateSummaryState(details, summary);

	details.addEventListener('toggle', () => {
		if (details.dataset.animating) {
			return;
		}

		updateSummaryState(details, summary);
	});

	summary.addEventListener('click', (event) => {
		if (prefersReducedMotion()) {
			return;
		}

		event.preventDefault();

		if (details.dataset.animating) {
			return;
		}

		if (details.open) {
			collapseDetails(details, content);
			return;
		}

		expandDetails(details, content);
	});
};

const init = () => {
	document
		.querySelectorAll('.wp-block-fc-block-fc-read-more')
		.forEach(initReadMore);
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', init);
} else {
	init();
}
